/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatedTokenResponse } from '../models/CreatedTokenResponse';
import type { CreateTokenRequest } from '../models/CreateTokenRequest';
import type { TokenSummaryResponse } from '../models/TokenSummaryResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminServiceTokenControllerService {
    /**
     * @param userUuid
     * @returns TokenSummaryResponse OK
     * @throws ApiError
     */
    public static listTokens(
        userUuid: string,
    ): CancelablePromise<Array<TokenSummaryResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/auth/admin/service-tokens',
            query: {
                'userUuid': userUuid,
            },
        });
    }
    /**
     * @param requestBody
     * @returns CreatedTokenResponse OK
     * @throws ApiError
     */
    public static createToken(
        requestBody: CreateTokenRequest,
    ): CancelablePromise<CreatedTokenResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/admin/service-tokens',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param tokenId
     * @returns any OK
     * @throws ApiError
     */
    public static revokeToken(
        tokenId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/auth/admin/service-tokens/{tokenId}',
            path: {
                'tokenId': tokenId,
            },
        });
    }
}
